import NewsletterButton from './NewsletterButton';

export default NewsletterButton;
